// @ts-strict-ignore
import type { HTMLProps, ReactNode } from "react";

import type { Size } from "@shared/types/sizes";

import * as styles from "./ContentWrapper.styles";

interface Props extends HTMLProps<HTMLDivElement> {
  type?: Size;
  children: ReactNode;
  noPadding?: boolean;
}

const ContentWrapper = ({ children, type, noPadding, ...rest }: Props) => {
  const contentWrapperStyles = [
    styles.contentWrapper.base,
    type && styles.contentWrapper[type],
    noPadding && styles.contentWrapper.noPadding,
  ];

  return (
    <div css={contentWrapperStyles} {...rest}>
      {children}
    </div>
  );
};

export { ContentWrapper };
